import { useCampuses } from '@/store/org/hooks';
import { Input, Select, SelectItem } from '@/components/ui';
import { makeOnChangeHandler } from './helpers';
import type { BasicSelectProps } from './types';
import { strictlyCompact } from '@/lib/compact';

export interface Props extends BasicSelectProps {
  value?: string | string[];
  onChangeMultiple?: (ids: string[]) => void;
  onChangeSingle?: (id: string) => void;
  isReadOnly?: boolean;
}

export function CampusSelect({
  label,
  variant,
  startContent,
  placeholder,
  multiple,
  value,
  isDisabled,
  isReadOnly,
  onChange,
  onChangeMultiple,
  onChangeSingle,
  className,
}: Props) {
  const { list: items, lookup } = useCampuses();
  const onChangeHandler = makeOnChangeHandler({
    multiple,
    anyTarget: onChange,
    multipleTarget: onChangeMultiple,
    singleTarget: onChangeSingle,
  });
  const defaults = Array.isArray(value) ? value : strictlyCompact([value]);

  if (isReadOnly) {
    const display = defaults
      .map((id) => lookup[id]?.data.name)
      .filter((name) => name?.length)
      .join(', ');

    return (
      <Input
        isReadOnly
        label={label}
        value={display}
        className={className}
        placeholder='Unassigned'
      />
    );
  }

  return (
    <Select
      variant={variant}
      startContent={startContent}
      placeholder={placeholder}
      label={label}
      aria-label='Campus'
      isDisabled={isDisabled}
      selectionMode={multiple ? 'multiple' : 'single'}
      onChange={onChangeHandler}
      defaultSelectedKeys={defaults}
      className={`text-gray-800 ${className}`}
      items={items}
    >
      {(item) => <SelectItem key={item.id}>{item.data.name}</SelectItem>}
    </Select>
  );
}
